import Cookies from 'js-cookie';
import jwt_decode from 'jwt-decode';

export default class SessionService {
  constructor() {}

  StoreAccessToken = (accessToken) => {
    Cookies.set('accessToken', accessToken, {
      expires: 7,
      domain: process.env.REACT_APP_MAIN_DOMAIN,
    });
  };

  ResolveAccessToken = () => {
    const result = Cookies.get('accessToken');
    return result;
  };

  CheckIsAccessTokenValid = () => {
    let result = false;
    const accessToken = this.ResolveAccessToken();
    if (accessToken) {
      var token = jwt_decode(accessToken);
      const validUntilUtc = token.exp;
      if (validUntilUtc) {
        const now = new Date(new Date().toUTCString());
        const validUntil = new Date(parseInt(validUntilUtc, 10) * 1000);
        if (now <= validUntil) {
          result = true;
        }
      }
    }
    return result;
  };

  RemoveAccessToken = () => {
    Cookies.remove('accessToken');
  };

  StoreRefreshToken = (refreshToken) => {
    Cookies.set('refreshToken', refreshToken, {
      expires: 7,
      domain: process.env.REACT_APP_MAIN_DOMAIN,
    });
  };

  ResolveRefreshToken = () => {
    const result = Cookies.get('refreshToken');
    return result;
  };

  RemoveRefreshToken = () => {
    Cookies.remove('refreshToken');
  };

  StoreUserDetails = (userDetails) => {
    const deatils = JSON.stringify(userDetails);
    Cookies.set('userDetails', deatils, { expires: 7 });
  };

  ResolveUserDetails = () => {
    let result = null;
    const json = Cookies.get('userDetails');
    if (json) {
      result = JSON.parse(json);
    }
    return result;
  };

  ResolveCurrentUser = () => {
    let result = null;
    const json = Cookies.get('userDetails');
    if (json) {
      result = JSON.parse(json);
    }
    return result;
  };

  RemoveUserDetails = () => {
    Cookies.remove('userDetails');
  };

  Logout = () => {
    this.RemoveAccessToken();
    this.RemoveRefreshToken();
    this.RemoveUserDetails();
  };
}
